module Meevo.Plugins.MeevoMessenger {

    export class MeevoMessengerClientSideNavController {
        displayAccordion: boolean;

        static $inject = [
            '$mdSidenav',
            '$scope'
        ];

        constructor(
            protected $mdSidenav: ng.material.ISidenavService,
            protected $scope: angular.IScope
        ) {
            $scope.$watch(() => this.$scope.client, (newValue, oldValue) => {
                if (!newValue) return;
                // It's necessary to start correctly meevo-client-detail-accordion
                this.displayAccordion = true;
            });

            $scope.$watch(() => this.$mdSidenav('MeevoMessengerClient').isOpen(), (newValue, oldValue) => {
                if (oldValue && !newValue) {
                    this.closeMenu();
                }
            });
        }

        closeMenu() {
            this.$mdSidenav('MeevoMessengerClient').close().then((o) => {
                this.$scope.client = null;
                this.displayAccordion = false;
            });
        }       
    }

    // controller registration with module
    angular.module('meevo.plugins.meevoMessenger')
        .controller('meevo.plugins.meevoMessenger.MeevoMessengerClientSideNavController', MeevoMessengerClientSideNavController);
}
